<div class="flex-left-column light-control-host" id="dialog-host">
  <div class="flex-center-row">
    <h2 class="panel-title">
      <ng-container *ngIf="!!integration; else newIntegration">Update Add On</ng-container>
      <ng-template #newIntegration>Configure New Add On</ng-template>
    </h2>
  </div>
  <form class="full-width" [formGroup]="integrationSettingsFormModel" (ngSubmit)="onSaveClick()">
    <div class="flex-center-row margin-top full-width">
      <h4>Add on type:</h4>
      <ng-container *ngIf="!integration; else existingIntegration">
        <div class="select-wrapper flex-center-row spacer">
          <select class="arpio-select margin-left spacer" formControlName="integrationType">
            <option></option>
            <option *ngFor="let i of entitledIntegrations" [value]="i.integrationType">
              {{ i.displayString }}
            </option>
          </select>
        </div>
      </ng-container>
      <ng-template #existingIntegration>
        <div class="margin-left">{{ integration.config.getTypeDisplayString() }}</div>
        <input
          id="integration-type"
          type="hidden"
          [value]="integration.config.getIntegrationType()"
          formControlName="integrationType"
        />
      </ng-template>
    </div>
    <div>
      <h4 class="margin-top">Description</h4>
      <div class="flex-center-row full-width">
        <input
          id="application-notification-emails-input"
          class="arpio-input spacer"
          type="text"
          formControlName="integrationName"
          placeholder="Briefly describe this instance of this add on"
        />
      </div>
    </div>
    <div>
      <ng-container [ngSwitch]="integrationSettingsFormModel.value.integrationType">
        <ng-container *ngSwitchCase="'spotByNetApp'">
          <spot-by-netapp-settings formControlName="integrationConfig"></spot-by-netapp-settings>
        </ng-container>
      </ng-container>
    </div>

    <div class="flex-center-row margin-top full-width">
      <div class="spacer"></div>
      <button class="arpio-secondary-button" (click)="onCancelClick()" [disabled]="saving" type="button">CANCEL</button>
      <button
        busy-button
        [busy]="saving"
        id="conclude-button"
        class="arpio-button margin-left"
        type="submit"
        [disabled]="saving || !valid"
      >
        SAVE
      </button>
      <div class="spacer"></div>
    </div>
  </form>
</div>
